export class FeesIncrease {
    public ID: number;
    public HashCode: string;
    public SchoolID: number;
    public CourseID: number;
    public CourseYearID: number;
    public MediumID: number;
    public AcademicYearID: number;
    public FeesCollected: string;
    public FeesIncrease: string = "";
    public FeesProposal: string = "";
    public YearID: number;
    public TotalFeesAmount: number;
    public feesIncreaseList: Array<any> = [];
    public Remark: string = "";
    public action: number;
}

// export class FeesIncreaseList {
//     public ID: number = 0;
//     public HashCode: string;
//     public SchoolID: number;
//     public CourseID: number;
//     public CourseYearID: number;
//     public MediumID: number;
//     public AcademicYearID: number;
//     public YearID: number;
//     public Remark: string = "";
// }